<template>
    <el-cascader
        filterable
        v-model="val"
        :options="options"
        @change="handleChange"
        :props="defaltProps"
        style="width: 100%"
        :placeholder="placeholder"
    ></el-cascader>
</template>

<script>
import options from "@/jslibs/area.js";
export default {
    props: {
        placeholder: {
            type: String,
            default: "请选择地址",
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const format = (options) => {
            const ops = JSON.parse(JSON.stringify(options));
            const deep = (ops) => {
                ops.forEach((option) => {
                    if (option.children && option.children.length == 0) {
                        option.children = null;
                    } else {
                        deep(option.children);
                    }
                });
            };
            deep(ops);
            return ops;
        };
        return {
            options: format(options),
            val: "",
            defaltProps: {
                value: "id",
                label: "zh_name",
            },
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val.map((x) => +x);
            },
            immediate: true,
        },
    },
    methods: {
        handleChange(val) {
            this.$emit("change", val);
            this.$emit("input", val);
        },
    },
};
</script>

<style></style>
